import { render, staticRenderFns } from "./e-overlay-block.vue?vue&type=template&id=215af8c8&lang=pug"
import script from "./e-overlay-block.vue?vue&type=script&lang=js"
export * from "./e-overlay-block.vue?vue&type=script&lang=js"
import style0 from "./e-overlay-block.vue?vue&type=style&index=0&id=215af8c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports